import { render, staticRenderFns } from "./b2bfailedordersubmission.vue?vue&type=template&id=b63e80bc&scoped=true"
import script from "./b2bfailedordersubmission.vue?vue&type=script&lang=js"
export * from "./b2bfailedordersubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63e80bc",
  null
  
)

export default component.exports